<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <!--page content-->
            <div class="admin-page-content">
                <div class="internal-container">
                    <div class="bullentin-questin-answer">
                        <div class="questions">
                            Attachment Group List
                            <div class="pagebutton" v-if="user_role == 1">
                                <router-link class="themebutton" v-bind:to="{name: 'AddAttachmentGroup'}">
                                    <span>Add New Group</span>
                                </router-link>
                            </div>
                        </div>
                        <div class="answers">
                            <!--{{groupArr}}-->
                            <b-list-group>
                                <template v-for="(groupInfo, index) in groupArr">
                                    <b-list-group-item>
                                         {{groupInfo.text}}
                                        <router-link title="Edit It" class="btn btn-primary pull-right" v-bind:to="{name: 'EditAttachmentGroup',params:{id:groupInfo.value}}">
                                            <i class="fa fa-pencil" aria-hidden="true"></i>
                                        </router-link>
                                        <template v-if='groupInfo.status == "active"'>
                                            <button type="button" title="Make It Inactive" class="btn mr-2 btn-danger pull-right" v-on:click="changeStatus(groupInfo.value)">
                                                <i class="fa fa-eye-slash" aria-hidden="true"></i>
                                            </button>
                                        </template>
                                        <template v-else>
                                            <button type="button" title="Make It Active" class="btn mr-2 btn-primary pull-right" v-on:click="changeStatus(groupInfo.value)">
                                                <i class="fa fa-eye" aria-hidden="true"></i>
                                            </button>
                                        </template>
                                    </b-list-group-item>
                                </template>

                            </b-list-group>
                        </div>
                    </div>
                </div>
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import {commonMixins} from '../mixins/commonMixins';
    import {HTTP} from '../http-common.js';
    import { BListGroup } from 'bootstrap-vue';

    Vue.component("app-footer", Footer);
    Vue.component("b-list-group", BListGroup);

    export default {
        name: 'UserList',
        mixins: [commonMixins],
        data() {
            return {
                groupArr: "",
            }
        },
        created: function () {

        },
        mounted: function () {
            var self = this;
            $('.common-disable :input').attr('disabled', true);
            self.loadGroups();
        },
        methods: {
            cancelUserDetails: function () {
                var self = this;
                self.is_Update = false;
                $('.common-disable :input').attr('disabled', true);
            },
            EditButton: function () {
                var self = this;
                self.is_Update = true;
                $('.common-disable :input').removeAttr('disabled');
            },

            loadGroups: function () {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    params: {
                        'id': 0,
                    }
                };
                self.showLoader();
                HTTP.get("attachment_group_list", config)
                    .then(function (response) {
                        if (response.data.code == '200') {
                            self.groupArr = response.data.content;
                        }
                        self.hideLoader();
                    })
                    .catch(function (err) {
                        self.hideLoader();
                        self.catchHandler(err, function () {});
                    });
            },
            changeStatus: function (id) {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                var fields = {
                    id: id,
                };

                this.$validator.validateAll().then((result) => {
                    if (result) {
                        HTTP.post('changeattachmentstatus', fields, config)
                            .then(function (response) {
                                if (response.data.status == "success") {
                                    self.groupArr = response.data.content;
                                }
                            })
                            .catch(function (err) {
                                self.catchHandler(err, function () {});
                            });

                    }
                });
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            parseColor: function (data) {
                if (data.length > 10) {
                    var value = JSON.parse(data);
                    data = value.hex8;
                }
                return data;
            },
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/ListAttachmentGroup.vue